import { z } from 'zod';

export const basicInfoSchema = z.object({
  name: z.string().trim().min(1, { message: 'Matter name must be provided' }),
  code: z.string().optional(),
  tokenLimit: z.number().optional(),
});

export type BasicInfoForm = z.infer<typeof basicInfoSchema>;
